import {
	MARKET_BUYABLE_EXCLUDE,
	STORE_BUYABLE_EXCLUDE,
	STORE_ONLY_AVAILABLE,
} from 'shared/custom/constants/commonConstants';

export const PRODUCT_CARD_PROMO_ICONS_DEFAULT = [
	'PROMOICON_GR',
	'PROMOICON_CE',
	'PROMOICON_NLP',
	'PROMOICON_HV',
	'PROMORIBBON_COMBO',
	'PROMORIBBON_NXM_2BY1',
	'PROMORIBBON_NXM_3BY2',
	'PROMORIBBON_NXM_4BY3',
	'PROMORIBBON_NXM_5BY3',
	'PROMORIBBON_NXM_5BY4',
	'PROMORIBBON_NXM_6BY5',
	'PROMORIBBON_NXM_7BY6',
	'PROMORIBBON_NXM_8BY7',
	'PROMORIBBON_NXM_9BY8',
	'PROMORIBBON_NXM_10BY9',
	'PROMORIBBON_NXM_11BY10',
	'PROMORIBBON_NXM_12BY10',
	'PROMORIBBON_NXM_12BY11',
	'PROMORIBBON_NXM_16BY15',
	'PROMORIBBON_AHP',
	'PROMORIBBON_BF',
	'PROMORIBBON_HS',
	'PROMORIBBON_CD',
	'PROMOICON_VF',
	'PROMOICON_PC',
	'ONLINE_ONLY_SELLING_STORE',
	'DROPSHIP_ONLY_SELLING_STORE',
	'TAG_EXCLUSIVE',
	'COLOR',
];

export const PRODUCT_CARD_PROMO_ICONS_VALIDATE_STORE_EXCLUDE = {
	B2C: [MARKET_BUYABLE_EXCLUDE, STORE_ONLY_AVAILABLE, STORE_BUYABLE_EXCLUDE],
	B2B: ['PRO_MARKET_BUYABLE_EXCLUDE', 'PRO_STORE_ONLY_AVAILABLE', 'PRO_STORE_BUYABLE_EXCLUDE'],
};
export const PRODUCT_CARD_PROMO_ICONS = {
	B2C: [
		'PROMOICON_FP',
		'PROMOICON_CP',
		'PROMOICON_MSI',
		'PROMOICON_FP_REWARD',
		...PRODUCT_CARD_PROMO_ICONS_VALIDATE_STORE_EXCLUDE.B2C,
		...PRODUCT_CARD_PROMO_ICONS_DEFAULT,
	],
	B2B: [
		...PRODUCT_CARD_PROMO_ICONS_VALIDATE_STORE_EXCLUDE.B2B,
		...PRODUCT_CARD_PROMO_ICONS_DEFAULT,
	],
};

export const PRODUCT_CARD_PROMO_ICONS_IMG_URL = {
	PROMOICON_CE: 'iconosPromos/SB.svg',
	PROMOICON_NLP: 'iconosPromos/NLP.svg',
	PROMOICON_GR: 'iconosPromos/remate.svg',
	PROMORIBBON_COMBO: 'iconosPromos/combos.svg',
	PROMORIBBON_AHP: 'iconosPromos/precio_mayoreo.svg',
	PROMOICON_CP: 'iconosPromos/ahorramas_v.svg',
	PROMOICON_HV: 'iconosPromos/hipoteca-verde.svg',
	PROMOICON_FP: 'iconosPromos/producto_gratis_rvp.svg',
	PROMOICON_FP_REWARD: 'iconosPromos/icon-is-gift.svg',
	PROMOICON_MSI: 'iconosPromos/msi-new.svg',
	PROMORIBBON_NXM_2BY1: 'iconosPromos/2x1.svg',
	PROMORIBBON_NXM_3BY2: 'iconosPromos/3x2.svg',
	PROMORIBBON_NXM_4BY3: 'iconosPromos/4x3.svg',
	PROMORIBBON_NXM_5BY3: 'iconosPromos/5x3.svg',
	PROMORIBBON_NXM_5BY4: 'iconosPromos/5x4.svg',
	PROMORIBBON_NXM_6BY5: 'iconosPromos/6x5.svg',
	PROMORIBBON_NXM_7BY6: 'iconosPromos/7x6.svg',
	PROMORIBBON_NXM_8BY7: 'iconosPromos/8x7.svg',
	PROMORIBBON_NXM_9BY8: 'iconosPromos/9x8.svg',
	PROMORIBBON_NXM_10BY9: 'iconosPromos/10x9.svg',
	PROMORIBBON_NXM_11BY10: 'iconosPromos/11x10.svg',
	PROMORIBBON_NXM_12BY10: 'iconosPromos/12x10.svg',
	PROMORIBBON_NXM_12BY11: '',
	PROMORIBBON_NXM_16BY15: 'iconosPromos/16x15.svg',
};

export const FILTERED_PROMO_ICONS = [
	'PROMOICON_GR',
	'PROMOICON_CE',
	'PROMORIBBON_NXM_2BY1',
	'PROMORIBBON_NXM_3BY2',
	'PROMORIBBON_NXM_4BY3',
	'PROMORIBBON_NXM_5BY3',
	'PROMORIBBON_NXM_5BY4',
	'PROMORIBBON_NXM_6BY5',
	'PROMORIBBON_NXM_7BY6',
	'PROMORIBBON_NXM_8BY7',
	'PROMORIBBON_NXM_9BY8',
	'PROMORIBBON_NXM_10BY9',
	'PROMORIBBON_NXM_11BY10',
	'PROMORIBBON_NXM_12BY10',
	'PROMORIBBON_NXM_12BY11',
	'PROMORIBBON_NXM_16BY15',
	'PROMORIBBON_COMBO',
	'PROMOICON_FP',
	'PROMOICON_FP_REWARD',
	'PROMORIBBON_AHP',
	'PROMOICON_CP',
	'PROMOICON_VF',
	'PROMOICON_PC',
	'PROMOICON_MSI',
	'ONLINE_ONLY_SELLING_STORE',
	'DROPSHIP_ONLY_SELLING_STORE',
	'MARKET_BUYABLE_EXCLUDE',
	'STORE_ONLY_AVAILABLE',
	'STORE_BUYABLE_EXCLUDE',
	'PRO_STORE_ONLY_AVAILABLE',
	'TAG_EXCLUSIVE',
	'PROMOICON_NLP',
];

export enum PROMOTION_TYPES {
	PROMOICON_PC = 'PROMOICON_PC',
	PROMOICON_VF = 'PROMOICON_VF',
	PROMOICON_NLP = 'PROMOICON_NLP',
	PROMORIBBON_COMBO = 'PROMORIBBON_COMBO',
	PROMOICON_GR = 'PROMOICON_GR',
	PROMOICON_CE = 'PROMOICON_CE',
	ONLINE_ONLY_SELLING_STORE = 'ONLINE_ONLY_SELLING_STORE',
	PROMORIBBON_AHP = 'PROMORIBBON_AHP',
	PROMOICON_FP = 'PROMOICON_FP',
	PROMOICON_FP_REWARD = 'PROMOICON_FP_REWARD',
	PROMORIBBON_NXM_ = 'PROMORIBBON_NXM_',
	PROMOICON_CP = 'PROMOICON_CP',
	PROMORIBBON_NXM_2BY1 = 'PROMORIBBON_NXM_2BY1',
	PROMORIBBON_NXM_3BY2 = 'PROMORIBBON_NXM_3BY2',
	PROMORIBBON_NXM_4BY3 = 'PROMORIBBON_NXM_4BY3',
	PROMORIBBON_NXM_5BY3 = 'PROMORIBBON_NXM_5BY3',
	PROMORIBBON_NXM_5BY4 = 'PROMORIBBON_NXM_5BY4',
	PROMORIBBON_NXM_6BY5 = 'PROMORIBBON_NXM_6BY5',
	PROMORIBBON_NXM_7BY6 = 'PROMORIBBON_NXM_7BY6',
	PROMORIBBON_NXM_8BY7 = 'PROMORIBBON_NXM_8BY7',
	PROMORIBBON_NXM_9BY8 = 'PROMORIBBON_NXM_9BY8',
	PROMORIBBON_NXM_10BY9 = 'PROMORIBBON_NXM_10BY9',
	PROMORIBBON_NXM_11BY10 = 'PROMORIBBON_NXM_11BY10',
	PROMORIBBON_NXM_12BY10 = 'PROMORIBBON_NXM_12BY10',
	PROMORIBBON_NXM_12BY11 = 'PROMORIBBON_NXM_12BY11',
	PROMORIBBON_NXM_16BY15 = 'PROMORIBBON_NXM_16BY15',
	PROMOICON_MSI = 'PROMOICON_MSI',
}

export const EXTENDED_CATALOG_PROMO_ICON_IMG = {
	EXTEND_CATALOG_DC: 'iconosPromos/catalogo-extendido-dc.svg',
	EXTEND_CATALOG: 'iconosPromos/catalogo-extendido.svg',
};
